import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";

import {p1, p2} from "../plan/planitems/pl_commons";

const FnButton = ({checked, num, click}) => {
    const [hover, setHover] = useState(false);
    const [active, setActive] = useState(false)

    useEffect(() => {
        setActive(checked)
    }, [checked]);

    function action() {
        setActive(!active)
        click(num)
    }

    let bg = active?'var(--button-on)':'var(--inner-background)';

    const its = {
        height: p2,
        width: p2,

        fontSize: '12px',

        border: '1px solid rgba(0, 0, 0, 0.8)',

        background: bg,
        userSelect: 'none',
        filter: hover?'brightness(.8)':'none',

        padding: '5px',
        paddingTop: '7px',
        borderRadius: '0px',
    };

    return(
        <div
            onPointerOver={()=> setHover(true)}
            onPointerOut={() => setHover(false)}
            style={its}
            onClick={action}>
            {num}
        </div>
    )
}

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FnButton)
